<template>
  <div class="">
      <draggable
          class="dragAreaQuestionsChildren"
          tag="ul"
          :list="items"
          :group="{ name: 'g4' }"
          item-key="name"
          @end="changeQuestionChildren"
      >
        <template #item="{ index, element }">
          <li class="w-full border-b border-gray-200 last:border-none">
            <div class="flex justify-between pl-2 pb-1 pt-1 items-center" :data-debug-order="element.order" :data-debug-id="element.id">
              <span class="group flex w-3/4">
                <span class="text-neutral-200 text-xl font-normal leading-tight -mt-1 mr-1">L</span>
                <span class="text-gray-900 text-sm font-light leading-tight">{{ element.text }}</span>
              </span>
              <span class="group flex">
                  <RouterLink :to="{ name: 'QuestionSetQuestionShow', params: { question_set_id: element.question_set_id, question_id: element.id } }" class="network-button-color hover:text-gray-900">
                    <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    <span class="sr-only">, {{ element.id }}</span>
                  </RouterLink>
                  <button v-if="!isPilot" @click="openQuestionModal(element.question_set_id, element.question_section_id, element.id)" type="button" class="network-button-color hover:text-gray-900">
                    <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />
                  </button>
                  <button v-if="!isPilot" @click="destroy(element.id)" type="button" class="network-button-color hover:text-gray-900">
                    <TrashIcon class="m-1 h-6 w-6" aria-hidden="true" />
                  </button>
              </span>
            </div>
          </li>
        </template>
      </draggable>
  </div>
</template>

<script>
import {EyeIcon, PencilSquareIcon, TrashIcon} from "@heroicons/vue/20/solid";
import draggable from "vuedraggable";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import QuestionCreateEditFormComponent from "../Question/QuestionCreateEditFormComponent.vue";

export default {
  name: "NestedDraggableQuestionChildrenComponent",

  props: {
    items: {
      required: true,
      type: Array,
    },
  },
  components: {
    draggable,
    EyeIcon,
    PencilSquareIcon,
    TrashIcon,
  },
  computed: {
    isPilot() {
      return this.$store.state.onlyPilotNetwork;
    },
  },
  methods: {
    changeQuestionChildren() {
      this.$emit('save-change-question-children');
    },
    destroy(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/question-set/question/destroy/${id}`).then((res) => {
          this.$emit('save-change-question-children');
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
    openQuestionModal(questionSetId, questionSectionId, questionId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: QuestionCreateEditFormComponent,
            attrs: {
              questionSetId: questionSetId,
              questionSectionId: questionSectionId,
              questionId: questionId,
              onReloadIndex() {
                self.$emit('save-change-question-children');
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
  },
};
</script>